'use client'

import { motion } from 'framer-motion'
import { User } from 'lucide-react'
import type { RefObject } from 'react'

interface StepNomeProps {
  nome: string
  setNome: (valor: string) => void
  onSubmit: () => void
  inputRef: RefObject<HTMLInputElement | null>
}

export function StepNome({ nome, setNome, onSubmit, inputRef }: StepNomeProps) {
  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} className="w-full max-w-md mx-auto">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="text-center mb-4 sm:mb-6">
        <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-2xl bg-gradient-to-br from-purple-500 to-purple-700 flex items-center justify-center mx-auto mb-3 sm:mb-4 shadow-lg shadow-purple-500/30">
          <User size={24} strokeWidth={1.5} className="text-white" />
        </div>
        <h2 className="text-2xl sm:text-3xl font-semibold text-indigo-950 dark:text-white mb-2">Como podemos te chamar?</h2>
      </motion.div>
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 }}>
        <input ref={inputRef} type="text" value={nome} onChange={(e) => setNome(e.target.value)} placeholder="Seu nome" className="w-full px-4 py-3 rounded-xl bg-white/85 dark:bg-white/5 border border-purple-500/20 dark:border-white/10 text-indigo-950 dark:text-white placeholder:text-indigo-950/30 dark:placeholder:text-white/30 outline-none transition-all focus:border-purple-500/50 focus:bg-white/90 dark:focus:bg-white/8" autoComplete="name" />
        <button onClick={onSubmit} disabled={nome.trim().length < 2} className={`mt-4 w-full py-3.5 rounded-full font-medium text-sm transition-all ${nome.trim().length >= 2 ? 'bg-purple-600 hover:bg-purple-500 active:bg-purple-700 text-white shadow-lg shadow-purple-600/25 active:scale-[0.98]' : 'bg-white/85 dark:bg-white/5 text-indigo-950/30 dark:text-white/30 cursor-not-allowed'}`}>Continuar</button>
      </motion.div>
    </motion.div>
  )
}
